import React from 'react'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import { Props_SnippetImageAndTextBackground } from './ImageAndTextColourBackground.props'

export const SnippetImageAndTextBackground = (props: Props_SnippetImageAndTextBackground) => {
    const reversed = props.image?.position?.value === 'left';

    return (
        <section className={`snippet-image-and-text-background ${reversed ? 'snippet-image-and-text-background--reversed' : ''}`}>
            <div className="snippet-image-and-text-background__container">
                <div className="snippet-image-and-text-background__content">
                    <h2 className="snippet-image-and-text-background__title">{props.heading?.heading?.value}</h2>
                    <div className="snippet-image-and-text-background__text">
                    { Legacy_CompileMarkdown(props.markdown?.markdown?.value || '') }
                    </div>
                </div>
                <figure className="snippet-image-and-text-background__image-container">
                    <img 
                    className="snippet-image-and-text-background__image" 
                    src={props.image?.src?.value} 
                    alt={props.image?.alt?.value} 
                    loading='lazy'
                    />
                </figure>
            </div>
        </section>
    );
};